


































































import Vue from 'vue';
import TabsBase from '@/components/layout/TabsBase.vue';
import AlertsContainer from '@/components/ui/AlertsContainer.vue';
import { mapState } from 'pinia';
import { useUser } from '@/store/modules/user';

export default Vue.extend({
  components: {
    TabsBase,
    AlertsContainer,
  },
  computed: {
    ...mapState(useUser, ['firstAllowedTab']),
  },
  methods: {
    home(): void {
      this.$router.replace({
        name: this.firstAllowedTab.to.name,
      });
    },
  },
});
